import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../config/api';
import { getTrafficSource } from '../lib/trafficSource';

export default function WebsiteVisitTracker() {
 const {pathname,search} = useLocation();
 const trackedRoute = useRef(null);
 useEffect(() => {
  const route = pathname + search;
  if (/^\/(allano|email)/i.test(pathname) || trackedRoute.current === route) return;
  trackedRoute.current = route;
  // Queries may contain private data. Record only the page path, using the
  // existing attribution helper to preserve the arrival source while browsing.
  axios.post(`${API_URL}/api/v1/statistics/visit`, {path:pathname,traffic_source:getTrafficSource().source}, {withCredentials:true}).catch(() => {});
 }, [pathname,search]);
 return null;
}
